import styled, { css } from 'styled-components';
import { position, PositionProps } from 'styled-system';
/**
 * @typedef {TopPosition | CenterPositon | BottomPosition} ModalPosition - Possible Modal positions
 */

/** @typedef {"top"} TopPosition - Top Position. */
export const TOP_POSITION = 'top';

/** @typedef {"center"} CenterPositon - Center Position. */
export const CENTER_POSITION = 'center';

/** @typedef {"bottom"} BottomPosition - Bottom Position. */
export const BOTTOM_POSITON = 'bottom';

export const TRANSPARENT_MODAL = false;

type ModalPosition = typeof TOP_POSITION | typeof CENTER_POSITION | typeof BOTTOM_POSITON;

type ModalTransparency = typeof TRANSPARENT_MODAL;

interface Props extends PositionProps {
	modalPosition: ModalPosition;
	transparentModal: ModalTransparency;
}

/**
 * @param {ModalPosition} modalPosition - Possible positions of the modal content.
 */
const Backdrop = styled.div<Props>`
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	z-index: var(--modal-backdrop-z-index, 23);
	background-color: ${props =>
		props.transparentModal ? `transparent` : `var(--base-modal-backdrop, rgba(55, 57, 66, 0.8))`};
	display: flex;
	flex-direction: column;
	align-items: center;

	${({ modalPosition }) => {
		if (modalPosition === TOP_POSITION) {
			return css`
				justify-content: flex-start;
			`;
		}

		if (modalPosition === CENTER_POSITION) {
			return css`
				justify-content: center;
			`;
		}

		if (modalPosition === BOTTOM_POSITON) {
			return css`
				justify-content: flex-end;
			`;
		}

		return css`
			justify-content: flex-start;
		`;
	}}
	${position}
`;

export default Backdrop;
